var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "com-dialog g-certi-dialog",
      attrs: {
        title: "电子数据存证证书",
        visible: _vm.dialogVisible,
        "before-close": _vm.close,
        width: "980px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "g-certi-dialog-conent" }, [
        _c("div", { staticClass: "img-certi" }, [
          _vm.certUrl
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.certLoading,
                      expression: "certLoading"
                    }
                  ],
                  staticClass: "img-certi-a",
                  attrs: {
                    href: _vm.certUrl,
                    target: "_blank",
                    title: "点击放大"
                  }
                },
                [
                  _c("img", {
                    staticClass: "img-certi-img",
                    attrs: { src: _vm.certUrl },
                    on: {
                      loadstart: function($event) {
                        _vm.certLoading = true
                      },
                      load: function($event) {
                        _vm.certLoading = false
                      }
                    }
                  })
                ]
              )
            : _c(
                "a",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.certLoading,
                      expression: "certLoading"
                    }
                  ],
                  staticStyle: {
                    "min-height": "637px",
                    display: "inline-block"
                  },
                  attrs: { href: "javascript:void(0);", title: "点击刷新" },
                  on: {
                    click: function($event) {
                      return _vm.flushCertStatus()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: _vm.certUrl },
                    on: {
                      loadstart: function($event) {
                        _vm.certLoading = true
                      },
                      load: function($event) {
                        _vm.certLoading = false
                      }
                    }
                  })
                ]
              )
        ]),
        _c(
          "div",
          { staticClass: "right-btn-warp" },
          [
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: {
                  id: "tag-copy",
                  "data-clipboard-text": _vm.leftPad(
                    _vm.param.preservationId,
                    10,
                    "0"
                  ),
                  size: "small"
                },
                on: {
                  click: function($event) {
                    return _vm.copyText($event)
                  }
                }
              },
              [_vm._v("复制备案号")]
            ),
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: {
                  id: "tag-copy1",
                  "data-clipboard-text": _vm.param.preservationId,
                  size: "small"
                },
                on: {
                  click: function($event) {
                    return _vm.copyTextToQuery($event)
                  }
                }
              },
              [_vm._v("复制备案号并查询\n      ")]
            ),
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: { size: "small" },
                on: {
                  click: function($event) {
                    return _vm.downloadCert(1, _vm.param.preservationId)
                  }
                }
              },
              [_vm._v("下载图片证书")]
            ),
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: { size: "small" },
                on: {
                  click: function($event) {
                    return _vm.downloadCert(2, _vm.param.preservationId)
                  }
                }
              },
              [_vm._v("下载PDF证书")]
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.close }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f53d37ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f53d37ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/certiServiceDialog2.vue
// module id = bS2T
// module chunks = 125